export default __webpack_public_path__ + "static/media/102t.9ff526aa.jpg";